module.exports = __webpack_public_path__ + "files/8bf60da0d883de7b329d02f51b939afa.png";